import { put, call, takeLatest } from 'redux-saga/effects'
import { postEasyToken, getEasyToken, getPersonalInfo } from 'services'
import { ACTION_TYPES } from 'store/reducers/easyToken'

const {
  EASYTOKEN_REQUEST,
  EASYTOKEN_SUCCESS,
  EASYTOKEN_ERROR,
  EASYTOKEN_CREATE_REQUEST,
  EASYTOKEN_CREATE_SUCCESS,
  EASYTOKEN_CREATE_ERROR
} = ACTION_TYPES

export function *getToken() {
  try {
    const response = yield call(getEasyToken)
    yield put({ type: EASYTOKEN_SUCCESS, payload: response })
  } catch (err) {
    const personalInfo = yield call(getPersonalInfo)
    yield put({ type: EASYTOKEN_ERROR, payload: err, personalInfo })
  }
}

export function *createSeed({ payload }) {
  try {
    const response = yield call(postEasyToken, payload)
    yield put({ type: EASYTOKEN_CREATE_SUCCESS, payload: response })
  } catch (err) {
    const personalInfo = yield call(getPersonalInfo)
    yield put({ type: EASYTOKEN_CREATE_ERROR, payload: err, personalInfo })
  }
}

export default function *watchEasyToken() {
  yield takeLatest(EASYTOKEN_REQUEST, getToken)
  yield takeLatest(EASYTOKEN_CREATE_REQUEST, createSeed)
}
